export const checkEmailType = (isReason) => (isReason ? 'Inquiry' : 'Communicate');

export const defaultVal = (val) => val;
